import { Component, OnInit, Input } from "@angular/core";
import { TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "./i18n/scope";
import { MatTableModule } from "@angular/material/table";
import { CombinedHistoryChange, HistoryType } from "@models/history/HistoryModel";

@Component({
    selector: "history-detail",
    templateUrl: "./history-detail.component.html",
    styleUrls: ["./history-detail.component.scss"],
    viewProviders: [
        provideTranslationScope(scope),
    ],
    imports: [TranslatePipe, MatTableModule],
})
export class HistoryDetailComponent implements OnInit {
    @Input() changes: CombinedHistoryChange[];

    displayedColumn: string[] = ["Column", "OldValue", "NewValue"];
    dataSource: CombinedHistoryChange[];
    HistoryType = HistoryType;

    constructor() {}

    ngOnInit() {
        this.dataSource = this.changes;
    }
}
